import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { UsageDirectoryPage } from './directory';
import { UsageBranchDetailPage } from './branch-detail';

const UsagePage: React.FC = () => {
    return (
        <Routes>
            <Route path="/" element={<UsageDirectoryPage />} />
            <Route path="/branch/:branchId" element={<UsageBranchDetailPage />} />
        </Routes>
    );
};

export { UsagePage };   